<template>
  <div class="user-role-edit">
    <el-form
      ref="form"
      label-width="80px"
    >
      <el-form-item label="用户名：">
        {{ username }}
      </el-form-item>
      <el-form-item label="角色：">
        <div
          v-if="roles"
          class="roles-lists"
        >
          <el-table
            ref="rolesTable"
            :data="roles"
            style="width: 100%;"
            tooltip-effect="dark"
            @selection-change="roleSelectionChange"
          >
            <el-table-column
              type="selection"
              width="55"
            />
            <el-table-column
              prop="name"
              label="角色"
            />
          </el-table>
        </div>
      </el-form-item>
      <el-form-item>
        <el-button
          type="primary"
          size="small"
          @click="submit"
        >
          保存
        </el-button>
        <el-button
          size="small"
          @click="$router.back()"
        >
          取消
        </el-button>
      </el-form-item>
    </el-form>
  </div>
</template>
<style lang="less">
</style>
<script>
const debug = require('debug')('ccs:ctrl:user-role-edit');
import axios from 'axios';

export default {
	data() {
		return {
			username: '',
			roles: [],
			roleSelection: [] // 选择的角色
		};
	},
	async created() {
		await this.init();
	},
	methods: {
		async init() {
			const { username } = this.$route.params;
			const [roles, userRoles] = await Promise.all([
				axios.get('/api/roles'),
				axios.get(`/api/userRoles/${username}`)
			]);

			debug(
				'[init] username: %s, roles: %o, userRoles: %o',
				username,
				roles,
				userRoles
			);

			this.username = username;
			this.roles = roles;
			this.userRoles = userRoles;

			// 初始化勾选
			this.userRoles.roles.forEach(row1 => {
				this.roles.forEach(row => {
					if (row1.id === row.id) {
						this.$nextTick(() => {
							this.$refs.rolesTable.toggleRowSelection(row, true);
						});
					}
				});
			});
		},
		roleSelectionChange(selected) {
			this.roleSelection = selected;
		},
		async submit() {
			await axios.put(`/api/userRoles/${this.username}`, {
				roles: this.roleSelection.map(role => role.id)
			});
			this.$router.back();
		}
	}
};
</script>